<template>
  <div :style="[{'height':height}]" class="swiper-container">
    <nav-bar :main-index="3" @anchorJump="anchorJump"></nav-bar>
    <div class="swiper-wrapper">
      <div class="swiper-slide slide1">
        <div class="swiperTitle">
          <span class="subhead">全球证券期货交易系统</span>
        </div>
        <div class="swiperContent ani" swiper-animate-duration="1.5s"
             swiper-animate-effect="fadeInUp">
          <div>
            <div class="swiperContentTitle">对接全球交易市场</div>
            <div class="swiperContentText">连接世界各地的30余个交易所<br>以获取市场数据和进行交易</div>
            <div class="swiperContentText">高效且易于使用的下单功能</div>
            <div class="swiperContentText" style="position: absolute;">在一个平台上可以交易，监控，管理全球头寸</div>
          </div>
          
          <div>
            <div class="swiperContentTitle">完备的风险监控</div>
            <div class="swiperContentText">多类型风控指标，损失预测和盈利管理</div>
            <div class="swiperContentText">风险管理预警提示</div>
          </div>
          
          <div>
            <div class="swiperContentTitle">多币种资金统一结算</div>
            <div class="swiperContentText">多种方式成交单输入</div>
            <div class="swiperContentText">易于操作的结算流程</div>
          </div>
        
        </div>
        <img alt="证券期货交易系统" class="hiddenImg" src="../assets/images/productBg1.png">
      </div>
      
      <div class="swiper-slide slide2">
        <div class="swiperTitle">
          <span class="subhead">清算系统</span>
        </div>
        <div class="swiperContent ani" swiper-animate-duration="1.5s"
             swiper-animate-effect="fadeInUp">
          <div>
            <div class="swiperContentTitle">交易清算</div>
            <div class="swiperContentText">实时接收新交所，芝加哥商品交易所成交记录</div>
            <div class="swiperContentText">自动下载交易所商品合约、结算价</div>
            <div class="swiperContentText" style="position: absolute;">多维度平仓逻辑、成交监控、错单调整、交割管理</div>
          </div>
          
          <div>
            <div class="swiperContentTitle">报表数据</div>
            <div class="swiperContentText">生成清算报表及监管合规报表</div>
            <div class="swiperContentText">完成交易所头寸与资金对账</div>
          </div>
          
          <div>
            <div class="swiperContentTitle">资金结算管理</div>
            <div class="swiperContentText">标准化运营，降低运营失误和成本</div>
            <div class="swiperContentText">提高客户资金利用率及减少风险敞口</div>
            <div class="swiperContentText">程序自动化运行，创新技术方案简化</div>
          </div>
        
        </div>
        <img alt="清算系统" class="hiddenImg" src="../assets/images/productBg2.png">
      
      </div>
      
      <div class="swiper-slide slide3">
        <div class="swiperTitle">
          <span class="subhead" style="float: right;margin-right: 11%">远程开户系统</span>
        </div>
        <div class="swiperContent ani"
             swiper-animate-duration="1.5s" swiper-animate-effect="fadeInUp">
          <div>
            <div class="swiperContentTitle">极速便捷开户</div>
            <div class="swiperContentText">打破时间和空间的限制</div>
            <div class="swiperContentText">接轨国际交易，支持多种国际货币</div>
          </div>
          
          <div>
            <div class="swiperContentTitle">实人身份活体检测</div>
            <div class="swiperContentText">视频活体检测，银行卡四要素验证</div>
            <div class="swiperContentText">证监会指定授权机构发放的数字证书</div>
          </div>
        </div>
        
        <img alt="开户系统" class="hiddenImg" src="../assets/images/productBg4.png">
      
      </div>
      
      <div class="swiper-slide slide4">
        <div class="swiperTitle">
          <span class="subhead" style="float: right;margin-right: 11%">深度行情数据</span>
        </div>
        <div class="swiperContent ani" swiper-animate-duration="1.5s"
             swiper-animate-effect="fadeInUp">
          <div style="margin-left: 60%">
            <div class="swiperContentTitle">拥有多家交易所牌照</div>
            <div class="swiperContentText">拥有芝加哥商品交易所，港交所行情转发牌照</div>
            <div class="swiperContentText">可提供个人和机构芝加哥商品交易所，港交所的深度行情</div>
          </div>
        </div>
        
        <img alt="行情转发服务" class="hiddenImg" src="../assets/images/productBg3.png">
      
      </div>
    </div>
    
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>

<script>

  import navBar from '../components/navBar';

  import '../assets/css/animate.min.css'
  import {swiperAnimate, swiperAnimateCache} from '../assets/js/swiper.animate.min'
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';


  export default {
    name: 'index',
    data() {
      return {
        mySwiper: "",
        navIndex: this.$route.params.index,
        height: 0,
      }
    },
    components: {
      navBar: navBar,
    },
    mounted() {
      this.$nextTick(() => {
        this.initSwiper()

        this.anchorJump(this.navIndex)
      });
    },
    created() {
      this.height = window.innerHeight + "px";
    },
    methods: {
      initSwiper() {
        this.mySwiper = new Swiper('.swiper-container', {
          loop: true,
          autoplay: 5000,
          speed: 1000,
          mousewheelControl: true,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
          onInit: function (swiper) { //Swiper2.x的初始化是onFirstInit
            swiperAnimateCache(swiper); //隐藏动画元素
            swiperAnimate(swiper); //初始化完成开始动画
          },
          onSlideChangeEnd: function (swiper) {
            swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
          }
        });


      },
      anchorJump(index) {
        this.mySwiper.slideTo(index, 1000, true)
      }
    }
  }

</script>

<style scoped>
  .swiper-container {
    width: 100%;
    height: 100%;
    
  }
  
  .swiperTitle {
    padding-top: 311px;
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
  }
  
  
  .subhead {
    display: inline-block;
    text-align: center;
    height: 58px;
    font-size: 60px;
    font-family: Lantinghei SC;
    font-weight: bold;
    color: #fff;
    padding-top: 15px;
    margin-top: 33px;
    /* text-shadow: 0px 0px 3px rgb(235, 218, 218) */
  }
  
  /* .subhead:after {
    content: '';
    display: block;
    height: 1px;
    margin: 31px auto 0;
    width: 350px;
    background-color: #fff;
  } */
  
  .swiperContent {
    width: 100%;
    height: 35%;
    background-color: rgba(33, 37, 43, 0.9);
    position: fixed;
    bottom: 0;
    display: flex;
  }
  
  .swiperContent > div {
    flex: 1;
    color: #dddddd;
    text-align: center;
    margin-left: 12%;
    margin-top: 55px;
  }
  
  .swiperContentTitle {
    text-align: left;
    font-size: 20px;
    font-family: Lantinghei SC;
    font-weight: bold;
    color: #FFA63E;
  }
  
  .swiperContentText {
    text-align: left;
    font-size: 16px;
    font-family: Lantinghei SC;
    font-weight: 200;
    color: #FFFFFF;
    margin-top: 30px;
  }
  
  .swiper-button-next {
    top: 42%;
    margin-right: 5%;
    width: 40px;
    height: 74px;
  }
  
  .swiper-button-prev {
    top: 42%;
    margin-left: 5%;
    width: 40px;
    height: 74px;
  }
  
  .slide1 {
    background-image: url(../assets/images/productBg1.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  
  .slide2 {
    background-image: url(../assets/images/productBg2.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  
  .slide3 {
    background-image: url(../assets/images/productBg4.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  
  .slide4 {
    background-image: url(../assets/images/productBg3.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  
  .swiper-button-next {
    background-image: url("../assets/images/nextPage.png");
    background-size: 100%;
  }
  
  .swiper-button-prev {
    background-image: url("../assets/images/prevPage.png");
    background-size: 100%;
  }
  
  
  /*1280的设备屏幕*/
  @media (max-width: 1439px) {
    .swiperTitle {
      padding-top: 289px;
    }
    
    .subhead {
      padding: 0;
      margin: 0;
      font-size: 40px;
    }
    
    .swiperContent > div {
      margin-top: 36px;
    }
    .swiperContentTitle{
      font-size: 18px;
    }
    .swiperContentText{
      font-size: 14px;
    }
  }
  
  /*1440的设备屏幕*/
  @media (min-width: 1440px) and (max-width: 1679px) {
    .subhead {
      font-size: 48px;
    }
  }
  
  /*1680的设备屏幕*/
  @media (min-width: 1680px) and (max-width: 1919px) {
  
  }
  
  /*1920的设备屏幕*/
  @media (min-width: 1920px) {
  
  }

</style>



// WEBPACK FOOTER //
// src/components/product.vue